import { AxiosInstance } from "axios"
import { OrderChatResponse, SendChatMessageParams, ChatMessage } from "./orderChatTypes"
import { ServiceResponse } from "../../../core/api/apiTypes"

export enum OrderChatQuery {
    MESSAGES = "order-chat-messages",
}

export async function fetchOrderChatMessages(
    { orderId }: { orderId: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<OrderChatResponse> {
    const { data } = await axios.get(`/orders/${orderId}/messages`, { signal })
    return data
}

export async function sendOrderChatMessage(
    { orderId, payload }: SendChatMessageParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{ message: ChatMessage }>> {
    const { data } = await axios.post(`/meetingService/orders/${orderId}/messages`, { message: payload }, { signal })
    return data
}
